// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleSwitchSlimWithText_wrapper__wQ+zF","text":"ToggleSwitchSlimWithText_text__U3R2m","disabled":"ToggleSwitchSlimWithText_disabled__k0wD5"};